import { render, staticRenderFns } from "./RepresReportsPager.vue?vue&type=template&id=1855277c&scoped=true"
import script from "./RepresReportsPager.vue?vue&type=script&lang=js"
export * from "./RepresReportsPager.vue?vue&type=script&lang=js"
import style0 from "./RepresReportsPager.vue?vue&type=style&index=0&id=1855277c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1855277c",
  null
  
)

export default component.exports